import { render, staticRenderFns } from "./ProducerProductDetails.vue?vue&type=template&id=08589516&scoped=true&"
import script from "./ProducerProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProducerProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProducerProductDetails.vue?vue&type=style&index=0&id=08589516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08589516",
  null
  
)

export default component.exports